import React from "react";

const AboutUs = () => (
  <div className="container">
    <article>
      <h1 className="text-center">Mark And Jessica Goldberg</h1>
      <div className="pull-left margins">
        <img
          className="img img-responsive"
          src="/img/mark-and-jessica-goldberg.jpg"
          alt="Mark and Jessica Goldberg with their children"
        />
        <p class="caption text-center">
          Mark and Jessica Goldberg with their children
        </p>
      </div>
      <p>
        Within minutes of meeting Mark and Jessica Goldberg, you&rsquo;ll feel
        like they are old friends. While Jessica is bright, bubbly and
        ebullient, Mark matches her charm with a genuineness that is palpable.
        The pair radiates contentment. It is obvious that they are centered in
        their right place under the sun. &ldquo;We&rsquo;ve found our
        Shangri-La,&rdquo; muses Mark, &ldquo;We wake up happy to be here
        everyday.&rdquo; Telluride&rsquo;s laid-back mindset amidst wide-open
        spaces is a far cry from the fast-paced, metropolitan lifestyle the
        Goldbergs left behind in New York City.
      </p>

      <p>
        Mark and Jessica made the most of their urban experience, each of them
        finding success in high profile careers. Mark spent a decade of his
        adulthood working at a Boutique Investment Firm. Meanwhile, Jessica
        thrived as an event planner, helping to put together premier parties for
        Sex &amp; the City, The Sopranos and Elle Magazine. It was a connection
        through Jessica&rsquo;s work that brought the couple together in 1998.
        Mark&rsquo;s best friend and furniture designer Jonathan Sweet met
        Jessica through his girlfriend. Sweet immediately knew he had to
        introduce Mark to Jessica.
      </p>

      <p>
        Though hesitant after a run of bad blind-date luck, Mark agreed to try
        it one more time. Fourteen years, a wedding and one beautiful daughter
        later, they are both very glad they gave a blind date a chance. Although
        the Goldbergs enjoyed their high-energy life in Gramercy Park, their
        work schedules made finding time to spend together a challenge. After
        9/11, they started reevaluating their priorities and feeling a pull
        toward a simpler life.
      </p>

      <aside>
        <blockquote>
          <p>
            &ldquo;Buyers are finding unique and beautiful pieces, the artists
            are selling their work and we are getting the chance to live and
            work in paradise.&rdquo;
          </p>
        </blockquote>
      </aside>

      <p>
        Mark set off on a three-month sabbatical to Bhutan, Nepal and Thailand.
        He relished the cultures, the art, and the people. He went to visit a
        weaving center, which spawned his love and respect for handmade rugs.
        &ldquo;I spent time away from every daily routine I&rsquo;d ever known.
        I started to focus on what I wanted my future to look like. I wanted
        real depth. I wanted time. I wanted a family.&rdquo; He came home and
        proposed.
      </p>

      <p>
        Following their marriage in 2002, Mark and Jessica made traveling a
        priority. Vacations offered quality time together, the chance to see new
        and beautiful places and the opportunity to pursue their passions for
        scuba-diving and skiing. Skiing was what brought the Goldbergs to
        Telluride, but their first visit to Telluride in the summer was life
        altering. &ldquo;We went whitewater rafting and hiking, we had a great
        time,&rdquo; remembers Jessica. &ldquo;More importantly, we looked
        around and could see that the people here were focused on enjoying life
        everyday, and that convinced us that this is the place where we want to
        raise a family.&rdquo; One year later and ready to start their new life,
        Mark and Jessica pulled into town with a fully packed car, and their
        Golden Retriever, Dudley.
      </p>

      <p>
        &ldquo;It was July 4th,&rdquo; recalls Jessica, &ldquo;and it was like
        the town was hosting a giant &lsquo;Welcome Home&rsquo; party for us.
        There couldn&rsquo;t have been a better way to start out here.&rdquo;
        Mark spent his first few years in Telluride in the rug business, where
        he expanded his knowledge of and love for the art of rug weaving. As his
        experience in Telluride grew, he began to see a void in the retail
        landscape and his idea for Gold Mountain Gallery was born.
      </p>

      <aside>
        <blockquote>
          <p>
            &ldquo;We want to have something for everyone and every budget, from
            antiques from the 1800s that could be at home in a palace to
            affordable contemporary mountain styles.&rdquo;
          </p>
        </blockquote>
      </aside>

      <p>
        &ldquo;I especially wanted to create a space where local artists could
        be featured in a retail setting, where buyers could come and see local
        works on display and take them home,&rdquo; says Mark. &ldquo;There is
        such talent here. We are proud to represent Jill and Scott Rikker, Matt
        Downer, Andy Ward, Nicole Finger and more. It works out for everyone.
        Buyers are finding unique and beautiful pieces, the artists are selling
        their work and we are getting the chance to live and work in
        paradise.&rdquo;
      </p>

      <p>
        With their combined passion for interior design, Mark and Jessica
        continue to broaden the offerings at Gold Mountain Gallery. &ldquo;I
        still travel to go treasure hunting,&rdquo; says Mark. &ldquo;I look for
        antiques and unique pieces that are in meticulous condition.&rdquo; The
        gallery is home to a wide selection of furniture, accessories and rugs
        from around the world. &ldquo;We run the gamut,&rdquo; maintains
        Jessica. &ldquo;We want to have something for everyone and every budget,
        from antiques from the 1800s that could be at home in a palace to
        affordable contemporary mountain styles.&rdquo;
      </p>

      <p>
        Gold Mountain Gallery features select designers from New York City,
        including jewelry by CLZ Dezigns and furniture by their matchmaker,
        Jonathan Sweet. The Goldbergs bring New York City-style service to
        Telluride as well. &ldquo;My work ethic is strong, and I always want to
        exceed my clients&rsquo; expectations,&rdquo; says Mark. &ldquo;Whether
        it is trying out furniture or a rug in a client&rsquo;s home or
        providing maintenance and cleaning services, we make sure our clients
        are happy.&rdquo;Mark and Jessica Goldberg are living their dream.
      </p>

      <p>
        &ldquo;We get to help artists and get beautiful pieces of work into
        peoples homes to enjoy, and we get to raise our daughter in this special
        town.&rdquo; Most importantly, unlike the long days of separation that
        are required by a career on Wall Street, Mark loves that now he gets to
        see &ldquo;his girls everyday. &ldquo;They pop in to say hello, we go
        out for lunch or a hike or just sit on a bench outside the gallery and
        enjoy the view.&rdquo; They welcome you to stop by and join them.
      </p>
      <p className="pull-right">&mdash; Cindy Fusting</p>
    </article>
  </div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/AboutUs.js